export default __webpack_public_path__ + "alberta-fab-return-delivery.8bd2f1a5682ac5d2fe31.svg";